import { render, staticRenderFns } from "./TkOrderDetail.vue?vue&type=template&id=abbabc2e&scoped=true&"
import script from "./TkOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TkOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TkOrderDetail.vue?vue&type=style&index=0&id=abbabc2e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbabc2e",
  null
  
)

export default component.exports